const apiService = {
    //'api' : 'http://localhost:4001',
    'api' : 'https://apiadmin.rawson.gov.ar'
}

export default apiService;